import { render, staticRenderFns } from "./LoginGoogleOff.vue?vue&type=template&id=2ffe71f2&scoped=true"
import script from "./LoginGoogleOff.vue?vue&type=script&lang=js"
export * from "./LoginGoogleOff.vue?vue&type=script&lang=js"
import style0 from "./LoginGoogleOff.vue?vue&type=style&index=0&id=2ffe71f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe71f2",
  null
  
)

export default component.exports